import axios from "axios";
import moment from "moment";
import ethLogo from '../assets/images/etherscan-logo.svg';
import link1Logo from '../assets/images/link1.png';
import link2Logo from '../assets/images/link2.png';
import link3Logo from '../assets/images/link3.png';


export const trimAddress = (addr) => {
  return `${addr.substring(0, 6)}...${addr.substring(addr.length - 4)}`;
}

export const contract = {
  56 : {
    MULTICALL_ADDRESS: "0xcf591ce5574258ac4550d96c545e4f3fd49a74ec",
    NFT_ADDRESS: "0x9d4ad9315fe731368ebb16f62ac7336bfe0c27dd",
    STAKE_ADDRESS: "0x2b29ef937bd747846c83cdb324784b569e61c0ac",
    TOKEN_ADDRESS : "0x154d91190b442f6eF880ED1bAEF6bd04E34659C2",
    ROUTER_ADDRESS : "0x131a98c17FBace26Bf23c9ba62867a4E84E03E96",
    PAIR_ADDRESS : "0x0f7b2aefa0bec05c0a3f00e0bb6d29514063fded",
    WETH : "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c"
  },
  97 : {
    MULTICALL_ADDRESS: "0xa54fe4a3dbd1eb21524cd73754666b7e13b4cb18",
    NFT_ADDRESS: "0xCEb687cb74d0589C5E7eC14C4B80720f2EdF220c",
    STAKE_ADDRESS: "0xbde5011914ab9c34b5c215d17479350136964b91",
    TOKEN_ADDRESS : "0x348E1E5E071A24CfBD20b58E9ccbFd0D92905b43",
    ROUTER_ADDRESS : "0x463df7b0a06f3d06c41ba6549787ccf9e4c93d24",
    PAIR_ADDRESS : "0x5fff7742c714ea69f6439d19a5629876cff0ad3e",
    WETH : "0x55d398326f99059ff775485246999027b3197955"
  }
}

export const EXPLORE_URL="https://bscscan.com"
export const DEFAULT_CHAIN = 56;
// export const RPC = "https://data-seed-prebsc-1-s1.bnbchain.org:8545";
export const RPC = "https://bsc-dataseed1.bnbchain.org";
export const DECIMALS = 8;
export const URI_PREFIX = 'https://alchemy.mypinata.cloud/ipfs/';
export const NFT_SYMBOL = "MGP";
export const TOKEN_SYMBOL = "MCASH";
export const PROJECT_ID = '27b9720018bf7f8740936e6a6eb28604';
export const MORALIS_API_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJub25jZSI6IjBlYThjNjlhLTIxYjktNGNkMS04YmE5LWJlMGQwY2ZjNWZkOCIsIm9yZ0lkIjoiMzk3NTA2IiwidXNlcklkIjoiNDA4NDU0IiwidHlwZUlkIjoiOTY2YTU1NDQtMTUzNi00NzZmLThjM2EtZTA1MzZkZTc3ZjM5IiwidHlwZSI6IlBST0pFQ1QiLCJpYXQiOjE3MTkxNDUzMjksImV4cCI6NDg3NDkwNTMyOX0.srZNbAB19Qzp-jL9NA6PcePPI9qr69fJzSswMsz_rl0';
export const MORALIS_BASE_URL = "https://deep-index.moralis.io/api/v2.2/";
export const MORALIS_CHAIN_NAME = 'bsc'
// export const BACKEND_URL = "https://mining.devcodesaga.tech";
export const BACKEND_URL = "https://www.mgp-nfts.com/admin";
// export const BACKEND_URL = "http://localhost/ricesnetwork";




export const formatDate = (unixTime) => {
  try {
    let dateString = moment(unixTime).format('lll');
    return dateString;
  }
  catch (err) {
    console.log(err.message);
  }
}

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`, // Assuming your API routes are prefixed with /api
  headers: {
    'Content-Type': 'application/json',
  }
});

export const stakePeriod = ["1 Year", "2 Year"];


export const daysLeftFromTimestamp = (timestamp) => {
  // Get the current date and time
  const currentDate = new Date();

  // Parse the given timestamp
  const targetDate = new Date(timestamp);

  // Calculate the difference in time (in milliseconds)
  const timeDifference = targetDate - currentDate;

  // Convert the time difference from milliseconds to days
  const millisecondsInADay = 1000 * 60 * 60 * 24;
  const daysLeft = Math.ceil(timeDifference / millisecondsInADay);

  return daysLeft;
}


export const menuItems = [
  {
    name: 'Home',
    url: '/',
    external: false,
    icon: 'fa-solid fa-home',
    image: null,
    isMobile : true
  },
  {
    name: 'My NFTs',
    url: '/my-nft',
    external: false,
    icon: 'fa-solid fa-desktop',
    image: null,
    isMobile : true
  },
  {
    name: 'Staked NFTs',
    url: '/staked',
    external: false,
    icon: 'fa-solid fa-box-open',
    image: null,
    isMobile : true
  },
  {
    name: 'Marketplace',
    url: '#sec',
    external: true,
    icon: 'fa-solid fa-warehouse',
    image: null,
    isMobile : false
  },
  {
    name: 'Exchange',
    url: ' https://mgpswap.com/',
    external: true,
    icon: 'fa-solid fa-globe',
    image: null,
    isMobile : false
  },
  {
    name: 'Contract',
    url: 'https://bscscan.com/token/0x154d91190b442f6eF880ED1bAEF6bd04E34659C2',
    external: true,
    icon: null,
    image: ethLogo,
    isMobile : false
  },
  {
    name: 'Chart',
    url: 'https://www.dextools.io/app/en/bnb/pair-explorer/0xee36ab9e6042b7755e2555eaceda5793008da0b1?t=1719031181133',
    external: true,
    icon: 'fa-solid fa-globe',
    image: null,
    isMobile : false
  },
  {
    name: 'MCOIN Saving',
    url: 'https://saving-mmsc.com/',
    external: true,
    icon: null,
    image: link3Logo,
    isMobile : false
  },
  {
    name: 'MCASH Saving',
    url: 'https://mcash-saving.com/',
    external: true,
    icon: null,
    image: link1Logo,
    isMobile : false
  },
  {
    name: 'MCASH Mining(V1)',
    url: 'https://mgp-platform.com/',
    external: true,
    icon: null,
    image: link1Logo,
    isMobile : false
  },
  {
    name: 'MCASH Mining(V2)',
    url: 'https://mgp-mining.com/',
    external: true,
    icon: null,
    image: link2Logo,
    isMobile : false
  }
];

